import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"logo-figma"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M12 1.5H15.5C17.433 1.5 19 3.067 19 5C19 6.933 17.433 8.5 15.5 8.5H12V1.5Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M5 5C5 3.067 6.567 1.5 8.5 1.5H12V8.5H8.5C6.567 8.5 5 6.933 5 5Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M5 12C5 10.067 6.567 8.5 8.5 8.5H12V15.5H8.5C6.567 15.5 5 13.933 5 12Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M5 19C5 17.067 6.567 15.5 8.5 15.5H12V19C12 20.933 10.433 22.5 8.5 22.5C6.567 22.5 5 20.933 5 19Z"}}]},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M19 12C19 13.933 17.433 15.5 15.5 15.5C13.567 15.5 12 13.933 12 12C12 10.067 13.567 8.5 15.5 8.5C17.433 8.5 19 10.067 19 12Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 1.5V8.5M12 1.5H15.5C17.433 1.5 19 3.067 19 5C19 6.933 17.433 8.5 15.5 8.5M12 1.5H8.5C6.567 1.5 5 3.067 5 5C5 6.933 6.567 8.5 8.5 8.5M12 8.5H15.5M12 8.5H8.5M12 8.5V15.5M15.5 8.5C13.567 8.5 12 10.067 12 12C12 13.933 13.567 15.5 15.5 15.5C17.433 15.5 19 13.933 19 12C19 10.067 17.433 8.5 15.5 8.5ZM8.5 8.5C6.567 8.5 5 10.067 5 12C5 13.933 6.567 15.5 8.5 15.5M12 15.5H8.5M12 15.5V19C12 20.933 10.433 22.5 8.5 22.5C6.567 22.5 5 20.933 5 19C5 17.067 6.567 15.5 8.5 15.5","strokeWidth":"props.strokeWidth"}}]}]};

const LogoFigma = Vue.extend<IconProps>({
  name: 'LogoFigmaIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-figma',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoFigma;
